'use client'
import { createContext, useContext, useState } from 'react'

type AIActivityContextValue = {
  isAIRunning: boolean
  setAIRunning: (value: boolean) => void
}

const AIActivity = createContext<AIActivityContextValue>(null)

export const AIActivityProvider = ({ children }) => {
  const [isAIRunning, setAIRunning] = useState(false)

  return (
    <AIActivity.Provider
      value={{
        isAIRunning,
        setAIRunning,
      }}
    >
      {children}
    </AIActivity.Provider>
  )
}

export const useAIActivity = () => useContext(AIActivity)
